import { render, staticRenderFns } from "./accounts.vue?vue&type=template&id=2812d664&scoped=true&"
import script from "./accounts.ts?vue&type=script&lang=ts&"
export * from "./accounts.ts?vue&type=script&lang=ts&"
import style0 from "./accounts.scss?vue&type=style&index=0&id=2812d664&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2812d664",
  null
  
)

export default component.exports